import { Reducer } from 'redux';
import * as actionTypes from './actionTypes';
import * as utils from './utils';
import {
  FeedbackState,
  FeedbackActionTypes,
  FeedbackAddActionType,
  FeedbackUpdateActionType,
  FeedbackRemoveActionType,
} from './types';

/* State Shape
{
  [feedbackId]: Feedback,
  ...
}
*/

const initialState: FeedbackState = {};

const reducer: Reducer<
FeedbackState,
FeedbackActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD: return utils.add(state, action as FeedbackAddActionType);
    case actionTypes.UPDATE: return utils.update(state, action as FeedbackUpdateActionType);
    case actionTypes.REMOVE: return utils.remove(state, action as FeedbackRemoveActionType);
    case actionTypes.CLEAR: return {};
    default: return state;
  }
};

export default reducer;
